module.exports = __webpack_public_path__ + "static/media/logo.ee9e6855.jpg";